import { HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { FaMoneyBillWave, FaRegCalendarAlt, FaRegFileAlt, FaRegUser } from "react-icons/fa";

const META_ORDER = ["period", "currency", "customer", "preparedBy", "custom"];

const DATE_KEYWORDS = ["date", "period", "month", "year", "time", "تاريخ", "فترة", "شهر", "سنة", "وقت"];
const USER_KEYWORDS = [
  "user",
  "customer",
  "client",
  "owner",
  "manager",
  "prepared by",
  "name",
  "مستخدم",
  "عميل",
  "العميل",
  "اسم",
  "الاسم",
  "مدير",
  "أعد",
];
const CURRENCY_KEYWORDS = ["currency", "curr", "العملة"];

const includesKeyword = (text, keywords) =>
  keywords.some((keyword) => text.includes(keyword));

const getMetaKey = (item = {}) => {
  const normalizedKey = String(item?.key || "").trim();
  if (normalizedKey) {
    return normalizedKey;
  }

  const normalizedLabel = String(item?.label || "").trim().toLowerCase();

  if (includesKeyword(normalizedLabel, DATE_KEYWORDS)) return "period";
  if (includesKeyword(normalizedLabel, CURRENCY_KEYWORDS)) return "currency";
  if (includesKeyword(normalizedLabel, USER_KEYWORDS)) return "customer";
  return "custom";
};

const getMetaIcon = (item) => {
  const key = getMetaKey(item);

  if (key === "period") return FaRegCalendarAlt;
  if (key === "currency") return FaMoneyBillWave;
  if (key === "customer" || key === "preparedBy") return FaRegUser;
  return FaRegFileAlt;
};

const sortMetaItems = (items = []) =>
  [...items].sort((left, right) => {
    const leftIndex = META_ORDER.indexOf(getMetaKey(left));
    const rightIndex = META_ORDER.indexOf(getMetaKey(right));
    return (leftIndex === -1 ? META_ORDER.length : leftIndex) - (rightIndex === -1 ? META_ORDER.length : rightIndex);
  });

const renderMetaRow = (item, index, isRTL) => {
  const icon = getMetaIcon(item);

  return (
    <HStack
      key={`${item.key || item.label}-${item.value}-${index}`}
      justify={isRTL ? "flex-end" : "flex-start"}
      dir={isRTL ? "rtl" : "ltr"}
      spacing={2}
      color="gray.600"
      fontSize={{ base: "sm", md: "md" }}
    >
      <Icon as={icon} boxSize={4} />
      <Text fontWeight="medium">{item.value}</Text>
    </HStack>
  );
};

export default function UnifiedReportHeader({
  description,
  isRTL,
  reportMeta,
  subtitle,
  title,
}) {
  const orderedMeta = sortMetaItems(reportMeta).slice(0, 4);

  return (
    <VStack spacing={1} align="stretch"
    py={2}
    >
      <VStack spacing={1} align="center" textAlign="center">
        <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="black" color="gray.800" lineHeight="1.25">
          {title}
        </Text>
        {subtitle ? (
          <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="bold" color="gray.700" lineHeight="1.35">
            {subtitle}
          </Text>
        ) : null}
        {description ? (
          <Text fontSize={{ base: "sm", md: "md" }} color="gray.500" maxW="4xl">
            {description}
          </Text>
        ) : null}
      </VStack>

      {orderedMeta.length ? (
        <HStack align={isRTL ? "flex-end" : "flex-start"} spacing={4}>
          {orderedMeta.map((item, index) => renderMetaRow(item, index, isRTL))}
        </HStack>
      ) : null}
    </VStack>
  );
}
